var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "financeApplication__form__input financeApplication__form__input--radio",
      class: { "financeApplication__form__input--active": _vm.isActive },
    },
    [
      _c("input", {
        attrs: {
          type: "radio",
          name: _vm.name,
          id: _vm.id,
          disabled: _vm.disabled,
        },
        domProps: { value: _vm.radioValue, checked: _vm.isActive },
        on: { change: _vm.onChange },
      }),
      _vm._v(" "),
      _c("label", { attrs: { for: _vm.id } }, [_vm._v(_vm._s(_vm.label))]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }